import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbUmbClasse } from '@/models/alodb/AloDbUmbClasse'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getUmbClasses(): AxiosPromise<AlrContainer<AloBaseArray<AloDbUmbClasse>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/umbclasse', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbUmbClasse>>(JSON.parse(data),AloDbUmbClasse.createAloDbUmbClasseArray)
      }]
    })
  },
  getUmbClasse(id:number):AxiosPromise<AlrContainer<AloDbUmbClasse>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/umbclasse/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbUmbClasse>(JSON.parse(data),AloDbUmbClasse.createAloDbUmbClasseWithDetail)
      }]
    })
  },
  saveUmbClasse(umbClasse:AloDbUmbClasse):AxiosPromise<AlrContainer<AloDbUmbClasse>> {
    if(umbClasse.UMC_ID && umbClasse.UMC_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/umbclasse/${umbClasse.UMC_ID}`, 
        method: 'PUT',
        data: umbClasse,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUmbClasse>(JSON.parse(data),AloDbUmbClasse.createAloDbUmbClasseWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/umbclasse`, 
        method: 'POST',
        data: umbClasse,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUmbClasse>(JSON.parse(data),AloDbUmbClasse.createAloDbUmbClasseWithDetail)
        }]
      })    
    }
    
  }
  
}